var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { Payment } from "../Payment";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "../FulfillmentInstructions";
import { inject } from "tsyringe";
import { Availability } from "../Availability";
import { StreetAddressAvailabilityService } from "./StreetAddressAvailabilityService";
import { OnlineOrderingSettingsToken, } from "../OnlineOrderingSettings";
import { Money } from "../../core";
import { PurchaseOrderPriceService } from "../PriceService";
import { Restaurant } from "../Restaurant";
let PaymentAvailabilityService = class PaymentAvailabilityService {
    constructor(payment, fulfillmentInstructions, streetAddressAvailabilityService, onlineOrderingSettings, purchaseOrderPriceService, restaurant) {
        this.payment = payment;
        this.fulfillmentInstructions = fulfillmentInstructions;
        this.streetAddressAvailabilityService = streetAddressAvailabilityService;
        this.onlineOrderingSettings = onlineOrderingSettings;
        this.purchaseOrderPriceService = purchaseOrderPriceService;
        this.restaurant = restaurant;
        makeAutoObservable(this);
    }
    get paymentAddressAvailability() {
        if (!this.payment.isAddressRequired) {
            return Availability.available();
        }
        const { isFullAddressRequired, postCode, streetAddress } = this.payment.address;
        return Availability.composite([
            isFullAddressRequired
                ? this.streetAddressAvailabilityService.availability(streetAddress)
                : Availability.available(),
            postCode.availability,
        ]);
    }
    get fromTheOrderValue() {
        if (this.onlineOrderingSettings.prepayment.fromTheOrderValue === null) {
            return null;
        }
        return Money.fromBackend(this.onlineOrderingSettings.prepayment.fromTheOrderValue);
    }
    get hasPrepaymentError() {
        return this.prepaymentAvailability.isAvailable.isDefinitelyFalse;
    }
    get prepaymentAvailability() {
        const { medium } = this.payment;
        const { fulfillmentMethodType, fulfillmentTime } = this.fulfillmentInstructions;
        const { prepaymentOptions } = this.onlineOrderingSettings.prepayment;
        const { priceWithoutTip } = this.purchaseOrderPriceService;
        const isSelectedOfflinePayment = medium !== null && medium.type === "method";
        const isOnlinePaymentEnabled = this.restaurant.paymentMethods.includes("Online");
        return Availability.boolean({
            NoContactDeliveryRequiresOnlinePayment: isOnlinePaymentEnabled &&
                fulfillmentMethodType === "NoContactDelivery" &&
                isSelectedOfflinePayment,
            OrderValueRequiresOnlinePayment: isOnlinePaymentEnabled &&
                prepaymentOptions.includes("FromTheOrderValue") &&
                priceWithoutTip.finalValue !== null &&
                this.fromTheOrderValue !== null &&
                priceWithoutTip.finalValue.geq(this.fromTheOrderValue) &&
                isSelectedOfflinePayment,
            DeliveryRequiresOnlinePayment: isOnlinePaymentEnabled &&
                prepaymentOptions.includes("Delivery") &&
                fulfillmentMethodType === "Delivery" &&
                isSelectedOfflinePayment,
            TakeawayRequiresOnlinePayment: isOnlinePaymentEnabled &&
                prepaymentOptions.includes("Takeaway") &&
                fulfillmentMethodType === "Takeaway" &&
                isSelectedOfflinePayment,
            DineInRequiresOnlinePayment: isOnlinePaymentEnabled &&
                prepaymentOptions.includes("DineIn") &&
                fulfillmentMethodType === "DineIn" &&
                isSelectedOfflinePayment,
            PreorderRequiresOnlinePayment: isOnlinePaymentEnabled &&
                prepaymentOptions.includes("Preorder") &&
                fulfillmentTime !== null &&
                fulfillmentTime.type === "OnTime" &&
                !fulfillmentTime.date.isToday &&
                isSelectedOfflinePayment,
        });
    }
    get availability() {
        return Availability.composite([
            Availability.boolean({
                PaymentMediumMissing: this.payment.medium === null,
            }),
            this.prepaymentAvailability,
            this.paymentAddressAvailability,
        ]);
    }
};
PaymentAvailabilityService = __decorate([
    perRestaurant(),
    __param(1, inject(FulfillmentInstructionsToken)),
    __param(3, inject(OnlineOrderingSettingsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof Payment !== "undefined" && Payment) === "function" ? _a : Object, typeof (_b = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _b : Object, typeof (_c = typeof StreetAddressAvailabilityService !== "undefined" && StreetAddressAvailabilityService) === "function" ? _c : Object, Object, typeof (_d = typeof PurchaseOrderPriceService !== "undefined" && PurchaseOrderPriceService) === "function" ? _d : Object, typeof (_e = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _e : Object])
], PaymentAvailabilityService);
export { PaymentAvailabilityService };
